import { Typography } from '@mui/material';
import { ArrowIcon } from '../../../../../components/icons/ArrowIcon';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { FC } from 'react';

type ActiveContractsAlertModalProps = {
  isOpen: boolean;
  contractsCount: number;
  onClose: () => void;
  onSubmit: () => void;
};

export const ActiveContractsAlertModal: FC<ActiveContractsAlertModalProps> = ({
  isOpen,
  contractsCount,
  onClose,
  onSubmit,
}) => {
  const isPlural = contractsCount > 1;
  const pluralEntity = handlePluralEntity('contract', isPlural);

  return (
    <VyDialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      label={`Customer has an active ${pluralEntity}`}
      cancelButtonText="Cancel"
      warningText=""
      ctaText="Go to Contracts"
      ctaButtonProps={{
        endIcon: <ArrowIcon direction="right" />,
      }}
      onSubmit={onSubmit}
    >
      <Typography
        variant="body1"
        sx={{
          fontSize: 16,
          fontWeight: 400,
          color: "rgba(13, 27, 39, 0.87)"
        }}>
        This customer has {isPlural ? '' : 'an'} active {pluralEntity} in place. In order to change its status
        please terminate the
        {pluralEntity} first.
      </Typography>
    </VyDialog>
  );
};

function handlePluralEntity(word: string, isPlural: boolean) {
  const wordEnding = isPlural ? 's' : '';
  return `${word}${wordEnding}`;
}
